import { useRef, useState } from "react";
import { Upload, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, fileUrl, formatError } from "@/lib/api";

export const FileUpload = ({ value, onChange, kind = "image", testid, label }) => {
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const accept = kind === "image" ? "image/jpeg,image/png,image/webp,image/gif" : "audio/*";

  const pick = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", f);
    try {
      const { data } = await api.post("/admin/upload", fd);
      onChange(data.url, f);
      toast.success(kind === "image" ? "Immagine caricata" : "Audio caricato");
    } catch (err) { toast.error(formatError(err)); }
    finally { setBusy(false); e.target.value = ""; }
  };

  return (
    <div className="flex items-center gap-3">
      {kind === "image" && value && <img src={fileUrl(value)} alt="" className="h-16 w-16 object-cover border border-white/10" />}
      {kind === "audio" && value && <audio src={fileUrl(value)} controls className="h-9 max-w-[220px]" />}
      <input ref={ref} type="file" accept={accept} hidden onChange={pick} data-testid={`${testid}-input`} />
      <button type="button" onClick={() => ref.current.click()} disabled={busy} data-testid={`${testid}-btn`}
        className="inline-flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 text-xs font-mono-tga uppercase tracking-[0.15em] hover:border-emerald-500/60 hover:text-emerald-300 transition-colors disabled:opacity-60">
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Upload className="h-3.5 w-3.5" />}
        {busy ? "Caricamento…" : value ? "Sostituisci" : label || (kind === "image" ? "Carica immagine" : "Carica MP3")}
      </button>
      {value && (
        <button type="button" onClick={() => onChange("")} className="p-2 text-zinc-500 hover:text-rose-400" aria-label="Rimuovi" data-testid={`${testid}-remove-btn`}><X className="h-4 w-4" /></button>
      )}
    </div>
  );
};
